import { Schema as S } from "effect";

/**
 * Appointment summary for selection
 */
export const AppointmentSummarySchema = S.Struct({
  scheduleId: S.String,
  time: S.String,
  type: S.String,
});

export type AppointmentSummary = S.Schema.Type<typeof AppointmentSummarySchema>;

/**
 * Check-In Checked In Response
 * Successfully checked in to appointment
 */
export const CheckInCheckedInSchema = S.Struct({
  status: S.Literal("CHECKED_IN"),
  scheduleId: S.String,
});

/**
 * Check-In Select Appointment Response
 * Multiple appointments found, patient must select one
 */
export const CheckInSelectAppointmentSchema = S.Struct({
  status: S.Literal("SELECT_APPOINTMENT"),
  appointments: S.Array(AppointmentSummarySchema),
});

/**
 * Check-In No Appointment Response
 * No appointments found for today
 */
export const CheckInNoAppointmentSchema = S.Struct({
  status: S.Literal("NO_APPOINTMENT"),
});

/**
 * Check-In Response Schema
 */
export const CheckInResponseSchema = S.Union(
  [CheckInCheckedInSchema,
  CheckInSelectAppointmentSchema,
  CheckInNoAppointmentSchema]
);

export type CheckInResponse = S.Schema.Type<typeof CheckInResponseSchema>;

